import React, { Component } from "react";
import { connect } from "react-redux";
import { Link } from "react-router-dom";

import { loginUser } from "../../store/user";
import { generateInput } from "../utils/misc";

import { CircularProgress } from "@material-ui/core";
import { Button } from "@material-ui/core";

import Form from "../utils/Form";

class Login extends Component {
    fields = [
        generateInput({
            name: "email",
            type: "email",
            autoComplete: "on",
            placeholder: "enter your email",
            icon: "fas fa-envelope",
        }),

        generateInput({
            name: "password",
            type: "password",
            min: 6,
            max: 30,
            placeholder: "enter your password",
            icon: "fas fa-lock",
        }),
    ];

    onSubmit = formValues => this.props.loginUser(formValues);

    render() {
        const { user } = this.props;

        return (
            <div className="login-form">
                <div className="form-container">
                    <div className="form-title">
                        <i className="fas fa-code-branch"></i>
                        <h2>log in to devChat</h2>
                    </div>

                    <div className="form-wrapper">
                        <div className="form">
                            <Form
                                form="login"
                                fields={this.fields}
                                onSubmit={this.onSubmit}
                                errorMessage={user.authErrorMessage}>
                                <Button className="submit-btn" type="submit">
                                    {user.loading ? <CircularProgress color="inherit" size="1.25rem" /> : "log in"}
                                </Button>
                            </Form>
                        </div>

                        <div className="register-link-wrapper">
                            don't have an account? <Link to="/register">register</Link>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

const mapStateToProps = ({ user }) => ({ user });

export default connect(mapStateToProps, { loginUser })(Login);
